export default __webpack_public_path__ + "static/media/group_unsplash.f562e927.png";